import React from 'react'
import _ from 'lodash'
import I18n from '../lib/i18n'
import ReactBottomSheet from 'react-bottomsheet'
import BottomSheetBtn from '../components/BottomSheetBtn'
import ShadesList from '../components/ShadesList'
import SizesList from '../components/SizesList'
import * as StyledComponent from '../styles'
import scrollIntoView from '../lib/scrollIntoView'
import withStore from '../lib/withStore'
import * as API from '../api'

// option list components
const option_list_components = {
  "color_option": ShadesList,
  "size_option": SizesList
}

class AddToCartBottomSheet extends React.Component {
  default_quantity = 1

  constructor(props){
    super(props)
    const { product, color_option_id } = props
    // set default state
    this.state = {
      default_options: {
        color_option_id: color_option_id,
        size_option_id: null,
      },
      option_type: '',
      list_options: [],
      product,
      ready: false,
      required_select_color_option: _.size(product.color_options) > 1,
      required_select_size_option: _.size(product.size_options) > 1,
      selected_options: {
        color_option_id: null,
        size_option_id: null
      },
      skus: [],
    }
  }
  componentDidMount() {
    const { product } = this.state
    API.fetchProduct(product.id)
    .then(this.saveSkus)
    .then(this.setDefaultToSelected)
    .then(this.handleProductLoaded)
    .catch(this.handleError)
  }

  getButtonLabel = () => {
    const {
      required_select_color_option,
      required_select_size_option,
      selected_options
    } = this.state
    const { color_option_id, size_option_id } = selected_options
    const is_color_selected = !required_select_color_option
      || (required_select_color_option && !_.isNull(color_option_id))
    const is_size_selected = !required_select_size_option
      || (required_select_size_option && !_.isNull(size_option_id))
    const label_key = is_color_selected && is_size_selected
      ? 'add_to_bag'
      : 'continue'
    return I18n.t(`containers.product_search_result.${label_key}`)
  }
  // when need to select size option, set default size option base on selected color
  getNewSizeOptionState = (skus, color_option_id) => {
    const size_option_skus = _.filter(skus, { color_option_id })
    // only use size option has stock to default
    // sort by product's size option sorting
    const size_options_with_stock = _.sortBy(_.filter(size_option_skus, sku => sku.stock_level > 0), (item) => {
      return _.findIndex(this.props.product.size_options, size_option => size_option.id === item.size_option_id)
    })
    const default_size_option_id = _.isEmpty(size_options_with_stock)
      ? _.head(size_option_skus).size_option.id
      : _.head(size_options_with_stock).size_option.id
    const required_select_size_option = _.size(size_option_skus) > 1
    const default_options = {
      ...this.state.default_options,
      size_option_id: default_size_option_id
    }
    return {
      default_options,
      required_select_size_option,
      selected_options: {
        size_option_id: required_select_size_option
          ? null
          : default_size_option_id
      }
    }
  }
  handleError = (err) => {
    const errors = API.handleError(err)
    this.props.store.save({ alert_message: errors.error_message }, () => {
      this.props.store.flash.open()
    })
    this.props.onClose()
  }
  saveSkus = (res) => {
    return new Promise((resolve, reject) => {
      try {
        const skus = _.get(res, 'data.product.skus', [])
        this.setState({ skus }, () => {
          resolve(res)
        })
      } catch (err) {
        reject(err)
      }
    })
  }
  setDefaultToSelected = (res) => {
    const {
      default_options,
      required_select_color_option,
      required_select_size_option,
      skus
    } = this.state
    let new_state = {}
    let selected_options = {}
    if (!required_select_color_option) {
      selected_options['color_option_id'] = default_options.color_option_id
    }
    if (!required_select_size_option) {
      const selected_sku = _.find(skus, { color_option_id: default_options.color_option_id })
      selected_options['size_option_id'] = selected_sku.size_option_id
    } else {
      // when need to select size option, set default size option base on selected color
      const new_size_related_states  = this.getNewSizeOptionState(skus, default_options.color_option_id)
      new_state = {
        ...new_state,
        ..._.omit(new_size_related_states, 'selected_options')
      }
      selected_options['size_option_id'] = new_size_related_states.selected_options.size_option_id
    }
    return new Promise((resolve, reject) => {
      this.setState({
        ...new_state,
        selected_options: {
          ...this.state.selected_options,
          ...selected_options
        }
      }, () => {
        resolve(res)
      })
    })
  }
  // after product is loaded, open options to user if required
  // when product does not required selecting color / size options, save to cart directly
  handleProductLoaded = (res) => {
    const {
      required_select_color_option,
      required_select_size_option,
    } = this.state
    if (!required_select_color_option && !required_select_size_option) {
      this.props.onOpen()
      this.handleSave()
    } else {
      const option_type = required_select_color_option ? 'color_option' : 'size_option'
      this.showOption(option_type)
      .then(()=>{
        this.props.onOpen()
        this.setState({
          ready: true
        }, () => {
          // for showing selected color option in viewport
          option_type === 'color_option' && scrollIntoView({target: '.selected-item', block: 'center'})
        })
      })
    }
  }
  // show product options (color / size)
  showOption = (option_type) => {
    const { product } = this.props
    const { default_options, selected_options, skus } = this.state
    return new Promise((resolve, reject) => {
      let list_options = []
      let default_option_id
      if (option_type === 'color_option') {
        list_options = product.color_options
        default_option_id = default_options[`color_option_id`]
      } else {
        // sort by product's size option sorting
        const size_option_skus = _.sortBy(_.filter(skus, {color_option_id: selected_options.color_option_id }), (item) => {
          return _.findIndex(product.size_options, size_option => size_option.id === item.size_option_id)
        })
        list_options = size_option_skus
        default_option_id = default_options[`size_option_id`]
      }
      this.setState({
        list_options,
        option_type,
        selected_options: {
          ...this.state.selected_options,
          [`${option_type}_id`]: default_option_id
        }
      }, () => {
        resolve({})
      })
    })
  }

  // save selected option for both color or size
  handleSelect = (target_option) => {
    const { option_type, skus } = this.state
    if (_.isEmpty(option_type)) return

    let new_state = {}
    let selected_options = {}
    // base on selected color option, update required_select_size_option and default size option
    if (option_type === 'color_option') {
      // when need to select size option, set default size option base on selected color
      const new_size_related_states  = this.getNewSizeOptionState(skus, target_option.id)
      new_state = {
        ...new_state,
        ..._.omit(new_size_related_states, 'selected_options')
      }
      selected_options['size_option_id'] = new_size_related_states.selected_options.size_option_id
    }
    this.setState({
      ...new_state,
      selected_options: {
        ...this.state.selected_options,
        ...selected_options,
        [`${option_type}_id`]: target_option.id
      }
    })
  }

  // // logic to determine next action, show color/size option or save to bag directly
  handleSubmit = () => {
    const {
      required_select_color_option,
      required_select_size_option,
      selected_options,
    } = this.state
    if (required_select_color_option && _.isNull(selected_options.color_option_id)) {
      // should not got here because color should be select in first step
      this.showOption('color_option')
    } else if (required_select_size_option && _.isNull(selected_options.size_option_id)) {
      this.showOption('size_option')
    } else {
      this.handleSave()
    }
  }

  // save selected sku to shopping bag
  handleSave = async () => {
    const { selected_options, skus } = this.state
    const { color_option_id, size_option_id } = selected_options
    const selected_sku = _.find(skus, {
      color_option_id,
      size_option_id
    })

    try {
      const databin_res = await API.fetchDatabin()
      const databin_shopping_cart_items = _.get(databin_res, 'data.data_bin.data.shopping_cart_items') || []
      let shopping_cart_items = _.cloneDeep(databin_shopping_cart_items)
      let selected_sku_in_databin = _.find(shopping_cart_items, { sku_id: selected_sku.id})

      _.isEmpty(selected_sku_in_databin)
        ? shopping_cart_items.push({ sku_id: selected_sku.id, quantity: 1 })
        : selected_sku_in_databin.quantity += 1

      // save shopping cart then close bottom sheet and open toast
      await API.updateDatabin({ shopping_cart_items })

      this.props.onAddToBagSuccess(selected_sku)
    } catch(err) {
      this.handleError(err)
    } finally {
      this.props.onClose()
    }
  }

  handleError = (err) => {
    const error = API.handleError(err)

    this.props.store.save({ alert_message: error.error_message }, () => this.props.store.flash.open())
  }

  render () {
    const {
      open,
      onClose
    } = this.props
    const {
      default_options,
      list_options,
      option_type,
      ready,
      selected_options,
    } = this.state

    // props for bottom sheet
    const bottom_sheet_props = {
      visible: open && ready,
      appendCancelBtn: false,
      list: [],
      onClose: onClose
    }

    // options list
    const OptionListComponent = option_list_components[option_type]
    const option_list_props = {
      options: list_options,
      selected: '',
      onSelect: this.handleSelect,
      onClose: this.props.onClose
    }
    switch(option_type) {
      case 'color_option':
        option_list_props.selected = _.isNull(selected_options.color_option_id)
          ? default_options.color_option_id
          : selected_options.color_option_id
        break
      case 'size_option':
        option_list_props.selected = _.isNull(selected_options.size_option_id)
        ? default_options.size_option_id
        : selected_options.size_option_id
        break
      default:
        // selected to open a option type which is not support yet
        break;
    }

    // props for bottom button
    const bottom_button_props = {
      label: this.getButtonLabel(),
      onClick: this.handleSubmit
    }

    return (
      <StyledComponent.BottomSheet>
        <ReactBottomSheet {...bottom_sheet_props}>
          { OptionListComponent && <OptionListComponent {...option_list_props} /> }
          <BottomSheetBtn {...bottom_button_props} />
        </ReactBottomSheet>
      </StyledComponent.BottomSheet>
    )
  }
}

AddToCartBottomSheet.defaultProps = {
  open: false,
  product: {},
  color_option_id: '',
  onClose: () => {},
}

export default withStore(AddToCartBottomSheet)



// WEBPACK FOOTER //
// ./src/components/AddToCartBottomSheet.js